/************************************************************************
8/14/17
All Actions for dashboard interactions
************************************************************************/
import { FETCH_DASHBOARD_DATA, FETCH_INFO_BY_LOCATION, ENLARGE_GRAPHS, FETCH_HEADCOUNT,
  SORT_BY_OPERATION, FETCH_HOURS_BY_FIELD, FETCH_MISSING_TIMESHEETS } from './types';
import { ROOT_URL } from '../constants';
import { error } from './index';
import axios from 'axios';
import moment from 'moment';
const $ = window.$;
const Materialize = window.Materialize;

/*****************************************************
  Asynchronous Functions
*****************************************************/
export function fetchData() {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchData`, {
      headers: { authorization: localStorage.getItem('token')  }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        //console.log(res)
        dispatch({type: FETCH_DASHBOARD_DATA, payload: res});
      }).catch((err) => dispatch(error(`There was an error fetching data for dashboard`)));
  }
}

/**
* fetchHeadCount(): Fetches headcounts based on submitted timesheets
* @returns {Array} Headcounts
* @called-in: ['/containers/dashboard.js]
**/
export function fetchHeadCount() {
  $('#preloader').css('display','block');
  let date = moment(document.getElementById('headcount-date').value).format('YYYY-MM-DD');

  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchHeadCount`, {
      params: { date },
      headers: { authorization: localStorage.getItem('token')  }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        dispatch({type: FETCH_HEADCOUNT, payload: res.headCount, date});
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching data for dashboard`));
      });
  }
}

/**
* fetchHoursByDepartment(): Fetches the hours by each department(broken up by cost centers)
* @returns {Array} Hours by department
* @called-in: ['/containers/dashboard.js]
**/
export function fetchHoursByDepartment() {
  //$('#preloader').css('display','block');
  if (document.getElementById('department-date-1').value === '' || document.getElementById('department-date-2').value === '') {
    return error('Two dates are required');
  }
  let dateFrom = moment(document.getElementById('department-date-1').value).format('YYYY-MM-DD');
  let dateTo = moment(document.getElementById('department-date-2').value).format('YYYY-MM-DD');

  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchHoursByDepartment`, {
      params: { dateFrom, dateTo },
      headers: { authorization: localStorage.getItem('token')  }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        //console.log(res);
        $('#preloader').css('display','none');
        //dispatch({type: FETCH_HOURS_BY_DEPARTMENT, payload: res.fieldHours });
        dispatch({ type: 'DUMMY' });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching data for dashboard`));
      });
  }
}
/**
* fetchHoursByField(): Fetches the hours in each field
* @returns {Array} Calculated field hours
* @called-in: ['/containers/dashboard.js]
**/
export function fetchHoursByField() {
  if (document.getElementById('field-date-1').value === '' || document.getElementById('field-date-2').value === '') {
    return error('Two dates are required');
  }
  $('#preloader').css('display','block');
  let dateFrom = moment(document.getElementById('field-date-1').value).format('YYYY-MM-DD');
  let dateTo = moment(document.getElementById('field-date-2').value).format('YYYY-MM-DD');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchHoursByField`, {
      params: { dateFrom, dateTo },
      headers: { authorization: localStorage.getItem('token')  }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        dispatch({type: FETCH_HOURS_BY_FIELD, payload: res.fieldHours });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching data for dashboard`));
      });
  }
}
/**
* fetchMissingTimesheets(): Fetches the employees who have missed timesheets(grouped by supervisors)
* @returns {Array} Missing timesheets
* @called-in: ['/containers/dashboard.js]
**/
export function fetchMissingTimesheets(date) {
  if (date === '') {
    date = moment().subtract(1, 'days').format('YYYY-MM-DD');
  }
  // Weekends should not be displayed. Most employees do not work Weekends and should not have timesheets
  if (moment(date).day() === 0 || moment(date).day() === 6) {
    Materialize.toast('Weekends do not have required timesheet submissions.', 3000, 'rounded');
    return {
      type: 'DUMMY'
    };
  }
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchMissingTimesheets`, {
      params: { date },
      headers: { authorization: localStorage.getItem('token')  }
    }).then((res) => JSON.parse(res.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        dispatch({type: FETCH_MISSING_TIMESHEETS, payload: res });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching data for dashboard`));
      });
  }
}

/*****************************************************
  Synchronous Functions
*****************************************************/
export function switchLocation(id) {
  return {
    type: FETCH_INFO_BY_LOCATION,
    payload: id
  }
}

export function enlargeGraphs() {
  return {
    type: ENLARGE_GRAPHS
  }
}

export function sortByOperation(id) {
  return {
    type: SORT_BY_OPERATION,
    payload: id
  }
}


































/* END */



// WEBPACK FOOTER //
// ./src/actions/dashboard_actions.js